
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spc-free-zone",
      function () {
        return require("private-next-pages/spc-free-zone.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spc-free-zone"])
      });
    }
  